import { format } from 'date-fns';
import { formatDisplay } from 'helpers/formatHelper';
import {
    Alert,
    AlertRecordValue,
    AlertRecordValueType,
    AlertStatus,
} from 'lib/alert/models';
import React from 'react';
import { useTranslation } from 'react-i18next';

const dateFormat = 'dd/MM/yyyy';

const FixedThresholdStatusText = ({
    alert,
    recordValues,
    since,
    latestDate,
}: {
    alert: Alert;
    recordValues: AlertRecordValue[];
    since: Date;
    latestDate: Date;
}) => {
    const { t } = useTranslation();
    const thresholdValue = recordValues.find(
        (v) => v.type === AlertRecordValueType.FIXED_THRESHOLD,
    );

    if (thresholdValue === undefined) {
        return <></>;
    }

    let { operation } = alert.condition;
    if (alert.status === AlertStatus.NOT_TRIGGERED) {
        operation = operation === 'lower' ? 'greater' : 'lower';
    }

    return (
        <div
            style={{
                marginLeft: '10px',
                fontSize: '1.1em',
            }}
        >
            <div>
                {t('alert.status.valueIs')} {t(`alert.create.${operation}`)}{' '}
                {t('alert.status.comparedWith')}{' '}
                {formatDisplay(
                    thresholdValue.value,
                    thresholdValue.valueType,
                    2,
                    'default',
                )}{' '}
                {t('alert.status.since')} {format(since, dateFormat)}.
            </div>
            <div
                style={{
                    marginTop: '5px',
                    fontSize: '0.8em',
                }}
            >
                {t('alert.status.lastUpdated')} {format(latestDate, dateFormat)}
            </div>
        </div>
    );
};

export default FixedThresholdStatusText;
